import ButtonGallery from "@/components/Triggers/ButtonGallery";
import { allTxt2ImgStyles, STYLE_IMAGES, Txt2ImgStyles } from "@/utils/constants";
import { Editor_Words } from "@/utils/lang/editor";
import { chakra } from "@chakra-ui/react";
import { langStore, translate } from "@noli/business";
import { observer } from "mobx-react-lite";
import React from "react";

const IStyleSelector: React.FC<{
  value: Txt2ImgStyles;
  setValue: (value: Txt2ImgStyles) => void;
  className?: string;
}> = ({ value, setValue, className }) => {
  return (
    <ButtonGallery
      className={className}
      textH={24}
      w="100%"
      mt="16px"
      panelTitle={translate(Editor_Words["txt2img-sd-style-title"], langStore.tgt)}
      collections={allTxt2ImgStyles}
      images={STYLE_IMAGES}
      storeValue={value}
      setStoreValue={setValue}
    />
  );
};

export const StyleSelector = chakra(observer(IStyleSelector));
